import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Flex } from 'src/components/Flex';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';

export const CheckInCallSetupGridColDef = (
    handleEdit: (rowId: number) => void,
    handleView: (rowId: number) => void,
    handleDelete: (rowId: number) => void
) => {
    return [
        createColumnDef({
            field: 'callName',
            headerName: 'Check-in Call Name',
        }),
        createColumnDef({
            field: 'callType',
            headerName: 'Check-in Type',
        }),
        createColumnDef({
            field: 'createdAt',
            headerName: 'Date Created',
        }),
        createColumnDef({
            field: 'actions',
            flex: 0,
            minWidth: 160,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Flex gap="8px">
                        <IconButton
                            onClick={() => {
                                return handleEdit(params.row.id);
                            }}
                            aria-label="edit"
                        >
                            <EditOutlinedIcon />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                return handleView(params.row.id);
                            }}
                            aria-label="view"
                        >
                            <VisibilityOutlinedIcon />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                return handleDelete(params.row.id);
                            }}
                            aria-label="delete"
                        >
                            <DeleteOutlineOutlinedIcon />
                        </IconButton>
                    </Flex>
                );
            },
        }),
    ];
};

export default CheckInCallSetupGridColDef;
